import GoogleIcon from "@mui/icons-material/Google";
import MicrosoftIcon from "@mui/icons-material/Microsoft";
import AccountTreeIcon from "@mui/icons-material/AccountTree";

interface ExternalLoginProvider {
  authenticationScheme: string;
  displayName: string;
  iconType: string;
}

interface ProviderIconProps {
  provider: ExternalLoginProvider;
}

export const ProviderIcon = (props: Readonly<ProviderIconProps>) => {
  const { provider } = props;
  const iconType = provider.iconType;
  if (!iconType) return <AccountTreeIcon />;
  if (typeof iconType === "string") {
    switch (iconType) {
      case "Google":
        return <GoogleIcon />;
      case "Microsoft":
        return <MicrosoftIcon />;
      default:
        return <AccountTreeIcon />;
    }
  }
  return <AccountTreeIcon />;
};
